import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import AddIcon from '@material-ui/icons/Add';
import { Link } from 'react-router-dom';
import { propNumber, propBool, } from '../../../../../../../helpers/custom-prop-types';
import SlideSearchStockCount from '../../../../../../Ui/SlideSearch/SlideSearchStockCount';
import Hover from '../../../../../../Ui/System/Hover';
const ProfessionalMyPageTopProffitSearchSlideCount = (props) => {
    const { adminFileCount, comparedToLastWeekSlideCount, isFree, myFileCount } = props;
    return (_jsxs("div", Object.assign({ className: 'professional_mypage_top_proffit_search_slide_count' }, { children: [_jsx(SlideSearchStockCount, { adminFileCount: adminFileCount, className: 'slide_stock', comparedToLastWeekSlideCount: comparedToLastWeekSlideCount, isFree: isFree, myFileCount: myFileCount }), _jsx(Hover, { children: _jsxs(Link, Object.assign({ className: 'slide_button', to: '/proffit_search/slide_add' }, { children: [_jsx("div", Object.assign({ className: 'button_icon' }, { children: _jsx(AddIcon, { className: 'icon_svg' }) })), _jsxs("div", Object.assign({ className: 'button_text' }, { children: ["\u30B9\u30E9\u30A4\u30C9\u3092", _jsx("br", { className: 'xl-is-show' }), "\u30B9\u30C8\u30C3\u30AF\u3059\u308B"] }))] })) })] })));
};
ProfessionalMyPageTopProffitSearchSlideCount.propTypes = {
    adminFileCount: propNumber(),
    comparedToLastWeekSlideCount: propNumber(),
    isFree: propBool().isRequired,
    myFileCount: propNumber(),
};
ProfessionalMyPageTopProffitSearchSlideCount.defaultProps = {
    adminFileCount: undefined,
    comparedToLastWeekSlideCount: undefined,
    myFileCount: undefined,
};
export default ProfessionalMyPageTopProffitSearchSlideCount;
